enum RequestStatus {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED'
}

enum UserRole {
  GUEST = 'guest',
  EX_PARENT = 'exParent',
  EX_STUDENT = 'exStudent',
  CURRENT_PARENT = 'currentParent',
  CURRENT_STUDENT = 'currentStudent',
  COUNSELLOR = 'counsellor',
  TEACHER = 'teacher',
  COORDINATOR = 'coordinator',
  SECTION_CHIEF = 'sectionChief',
  PRINCIPAL = 'principal',
  SENIOR_PRINCIPAL = 'seniorPrincipal',
  VICE_PRINCIPAL = 'vicePrincipal',
  MODERATOR = 'moderator',
  ADMIN = 'admin',
  CONTENT_CREATOR = 'contentCreator',
  HEAD_OF_SCHOOL = 'headOfSchool',
  DEPUTY_HEAD_OF_SCHOOL = 'deputyHeadOfSchool',
  CENTRAL_ACADEMIC_TEAM = 'centralAcademicTeam',
  NURSE = 'nurse',
  ETHER_BOT = 'etherBot',
  ETHER_EVENTS_BOT = 'etherEventsBot',
  SUPER_ADMIN = 'superAdmin',
  SCHOOL_OFFICE = 'schoolOffice',
  ANCILLARY_STAFF = 'ancillaryStaff'
}

enum Feature {
  POST_MODERATION = 'postModeration',
  ALLOW_PARENT_TO_POST_TO_SUBJECT_TEACHER = 'allowParentToPostToSubjectTeacher',
  SEND_MODERATION_MESSAGES_TO_CHATWOOT = 'sendModerationMessagesToChatwoot',
  ALLOW_BOSSES_TO_VIEW_POSTS = 'allowBossesToViewPosts',
  BLS_ATTENDANCE_TRACKER = 'blsAttendanceTracker',
  SHOW_STELLAR_PAYMENT_POST_TEXT = 'showStellarPaymentPostText',
  SEND_FIRST_PAYMENT_POST_FOR_NEW_ADMISSIONS = 'sendFirstPaymentPostForNewAdmissions',
  ALERTS_FOR_BUS_LEAVING_FROM_SCHOOL = 'alertsForBusLeavingFromSchool',
  ALERTS_FOR_BUS_REACHING_SCHOOL = 'alertsForBusReachingSchool',
  ENSURE_ID = 'ensureId',
  IMPORTANT_DOCS = 'importantDocs',
  ATTENDANCE_TRACKING = 'attendanceTracking',
  BUS_TRACKING = 'busTracking',
  STUDENT_ROLLOVER = 'studentRollover',
  STUDENTS_MARKS_TRACKER = 'studentsMarksTracker',
  MULTISELECT_VISBILITY_GROUPS = 'multiselectVisbilityGroups',
  NOTES_EXPLORER = 'notesExplorer',
  DAILY_CLASS_UPDATE = 'dailyClassUpdate',
  REMOVE_POST_OPTION = 'removePostOption',
  REPORT_POST_OPTION = 'reportPostOption',
  REPORT_USER_OPTION = 'reportUserOption',
  REPORT_COMMENT_OPTION = 'reportCommentOption',
  EDUTAIN_FEED = 'edutainFeed',
  ENLIGHT_FEED = 'enlightFeed',
  CHILD_ETHER = 'childEther',
  STAFF_ATTENDANCE = 'staffAttendance',
  PHOTO_ID_CARDS = 'photoIdCards',
  BONAFIDE = 'bonafide'
}

enum LoginFormStatus {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED'
}

enum SnackbarSeverityType {
  error = 'error',
  success = 'success',
  warning = 'warning',
  info = 'info'
}

enum PostType {
  REGULAR = 'REGULAR',
  KUDOS = 'KUDOS',
  ENLIGHT = 'ENLIGHT',
  LEAVE_APPLICATION = 'LEAVE_APPLICATION',
  INFIRMARY_UPDATE = 'INFIRMARY_UPDATE',
  AVAIL_LUNCH = 'AVAIL_LUNCH',
  ATTENDANCE_TRACKING = 'ATTENDANCE_TRACKING',
  BUS_TRACKING = 'BUS_TRACKING',
  MARKS_TRACKING = 'MARKS_TRACKING',
  NOTES_EXPLORER = 'NOTES_EXPLORER'
}

enum Status {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'IN_ACTIVE'
}

enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER'
}

enum Relation {
  FATHER = 'FATHER',
  MOTHER = 'MOTHER'
}
enum YesNoOption {
  True = 'true',
  False = 'false',
  No = 'No'
}

enum TransactionStatus {
  NOT_DEPOSITED = 'NOT DEPOSITED',
  CLEARED = 'CLEARED',
  DEPOSITED = 'DEPOSITED',
  BOUNCED = 'BOUNCED',
  CANCELLED = 'CANCELLED'
}

enum RelationType {
  FATHER = 'FATHER',
  MOTHER = 'MOTHER',
  GUARDIAN = 'GUARDIAN',
  STUDENT = 'STUDENT'
}

enum ConcessionWaiverType {
  CONCESSION = 'Concession',
  WAIVER = 'Waiver'
}

enum PaymentMode {
  CREDIT_CARD = 'Credit Card',
  OTHER_CARD = 'Other Card',
  DEBIT_CARD = 'Debit Card',
  NET_BANKING = 'Net Banking',
  E_MANDATE = 'E-Mandate',
  CASH = 'Cash',
  CHEQUE = 'Cheque',
  UPI = 'UPI',
  WALLET = 'Wallet',
  PAY_LATER = 'Pay Later',
  DEMAND_DRAFT = 'Demand Draft',
  CARDLESS = 'Cardless'
}
enum ConcessionType {
  DEPENDENT = 'DEPENDENT',
  INDEPENDENT = 'INDEPENDENT'
}

enum PaymentSchemeType {
  INSTALLMENTS = 'installments',
  FORMF = 'formF'
}

enum AdminUserRoles {
  FEE_CLERK = 'FEE_CLERK',
  FEE_ADMIN = 'FEE_ADMIN'
}

enum PaymentConcessionType {
  FIXED_PERCENTAGE = 'FIXED_PERCENTAGE',
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  DATE_WISE_PERCENTAGE = 'DATE_WISE_PERCENTAGE',
  DATE_WISE_AMOUNT = 'DATE_WISE_AMOUNT'
}

enum TripStatus {
  STARTED = 'STARTED',
  ENDED = 'ENDED'
}

enum StaffAttendanceStatus {
  All = 'All',
  PRESENT = 'PRESENT',
  ABSENT = 'ABSENT',
  LEAVE = 'LEAVE',
  HALF_DAY_PRESENT = 'HALF_DAY_PRESENT'
}

export {
  RequestStatus,
  UserRole,
  Feature,
  TransactionStatus,
  LoginFormStatus,
  Gender,
  SnackbarSeverityType,
  PostType,
  Status,
  Relation,
  YesNoOption,
  RelationType,
  ConcessionWaiverType,
  PaymentMode,
  ConcessionType,
  PaymentSchemeType,
  AdminUserRoles,
  PaymentConcessionType,
  TripStatus,
  StaffAttendanceStatus
};
